// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as CustomerConsentsApiModel from "../api-model/CustomerConsentsApiModel.bs.js";

function decodeChannels(channels) {
  return $$Array.map((function (channel) {
                return {
                        config_id: channel.consent_config_id,
                        title: channel.title,
                        enabled: channel.enabled
                      };
              }), channels);
}

function decodeApiModel(res) {
  return $$Array.map((function (consent) {
                var channels = consent.channels;
                return {
                        consent_type: consent.message_type,
                        title: consent.title,
                        message: consent.message,
                        compulsory: decodeChannels(Belt_Array.keep(channels, (function (x) {
                                    return !x.alterable;
                                  }))),
                        optional: decodeChannels(Belt_Array.keep(channels, (function (x) {
                                    return x.alterable;
                                  })))
                      };
              }), res.consents);
}

function execute(json) {
  return decodeApiModel(DeccoUtils$Catalyst.resolveResult(CustomerConsentsApiModel.t_decode(json), "CustomerConsentsEntityMapper.res"));
}

export {
  decodeChannels ,
  decodeApiModel ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
